import React from 'react';
import { Download } from "lucide-react";
const DownloadButton = ({ text, onClick }) => {
    return (
        <button
            onClick={onClick}
            className="flex gap-2 items-center justify-center cursor-pointer border border-white px-6 py-3 rounded-none text-sm hover:bg-white hover:text-[#0C2A45] transition">
            <span>{text}</span>
            <Download size={16} />
        </button>
    );
};

export default DownloadButton;